import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";
import { FailComponent } from "./fail.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { FailData } from "./entities/fail-data.interface";

export const FailPresetDefinition: OpenPresetModalDefinition<FailData> = {
	component: FailComponent,
	options: {
		wrap: false,
		size: ModalSizes.lg,
		cancelKey: "close",
		isPreset: PresetsComponentsEnum.confirm
	}
};
